<template>
	<BaseCard :is-editable="isEditable" :title="$t('lawyers_office').toString()" :is-toggleable="false" @clickEdit="$emit('edit')">
		<div v-if="lawyerOffice">
			<BaseCardRow :value="lawyerOffice.name" :label="$t('name')" />

			<BaseCardRow v-if="lawyerOffice.contact_name" :value="lawyerOffice.contact_name" :label="$t('contact_person')" />

			<BaseCardRow :value="street" :label="$t('street')" />

			<BaseCardRow :value="city" :label="$t('city')" />

			<BaseCardRow :value="lawyerOffice.phoneNumber" :label="$t('phone')" />

			<BaseCardRow :value="lawyerOffice.email" :label="$t('e_mail')" />
		</div>

		<div v-else class="font-bold">
			{{ $t('no_lawyer') }}
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'DamageAssessorCaseAssignedLawyerCard',

	components: {
		BaseCard,
		BaseCardRow,
	},

	props: {
		lawyerOffice: {
			type: Object,
			default: null,
		},

		isEditable: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		street() {
			if (!this.lawyerOffice) {
				return '-';
			}

			return concatArray([this.lawyerOffice.street, this.lawyerOffice.houseNumber]) || '-';
		},

		city() {
			if (!this.lawyerOffice) {
				return '-';
			}

			return concatArray([this.lawyerOffice.city?.zipCode, this.lawyerOffice.city?.name]) || '-';
		},
	},
};
</script>
